import { render, staticRenderFns } from "./DaftarRujukan.vue?vue&type=template&id=3712f605"
import script from "./DaftarRujukan.vue?vue&type=script&lang=js"
export * from "./DaftarRujukan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\Work\\laporan-rl\\sembiring_rekammedis\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3712f605')) {
      api.createRecord('3712f605', component.options)
    } else {
      api.reload('3712f605', component.options)
    }
    module.hot.accept("./DaftarRujukan.vue?vue&type=template&id=3712f605", function () {
      api.rerender('3712f605', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/app/rlexternal/rekapitulasi-kegiatan-pelayanan/DaftarRujukan.vue"
export default component.exports